import {fetchPriceObserver} from './pricing';

export default [fetchPriceObserver];
